import logo from './logo.svg';
import Counter from './components/Counter';
import './App.css';
import './components/Counter.css';

function App() {
  return (
    <div className="App">
      <Counter />
    </div>
  );
}

export default App;
